export default __webpack_public_path__ + "static/media/tamato2.ae5934fb.png";